import React from "react";
import { getEditorPlayhead } from "../../common/playhead_tracker.es6";
/* eslint-disable react/prop-types */
require("./AudioCue.scss");
import imagePlay from "./../../dist/images/play.svg";
import imagePause from "./../../dist/images/pause.svg";
import AudioCuePlayerBar from "./AudioCuePlayerBar";

export default class AudioCueComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
      deltaTime: 0,
      currentTime: 0,
      duration: 0,
      muted: false,
      audioPaused: true,
    };

    this.audioRef = React.createRef();
  }
  get audio() {
    return this.audioRef.current;
  }

  // A press during the preview makes the cue the learner's: the timeline leaves it alone.
  _takeOverFromPreview() {
    if (this.audio && getEditorPlayhead()?.playing) this.audio.dataset.learnerCue = "1";
  }

  playPause() {
    this._takeOverFromPreview();
    // The learner decides now: an earlier preview pause no longer resumes it.
    if (this.audio) delete this.audio.dataset.pausedByPreview;
    const shouldPlay = this.audio ? this.audio.paused : !this.state.playing;
    this.setState({ playing: shouldPlay }, () => {
      if (this.state.playing && this.audio) {
        this.audio.play();
      } else if (this.audio) {
        this.audio.pause();
      }
    });
  }

  onTimeUpdate = () => {
    if (!this.audio) return;
    this.setState({
      currentTime: this.audio.currentTime || 0,
      duration: isFinite(this.audio.duration) ? this.audio.duration : 0,
      audioPaused: this.audio.paused,
    });
  };

  onAudioEnded = () => {
    this.setState({ playing: false });
  };

  seek(sec) {
    if (!this.audio) return;
    this._takeOverFromPreview();
    this.audio.currentTime = sec;
    this.setState({ currentTime: sec });
  }

  toggleMute() {
    this.setState({ muted: !this.state.muted }, () => {
      if (this.audio) this.audio.muted = this.state.muted;
    });
  }

  applyVolume() {
    if (!this.audio) return;
    const v = parseFloat(this.props.state.volume);
    this.audio.volume = Number.isFinite(v) ? Math.min(1, Math.max(0, v / 100)) : 1;
  }

  componentDidMount() {
    this.applyVolume();
    if (this.audio) {
      this.audio.addEventListener("loadedmetadata", this.onTimeUpdate);
      this.audio.addEventListener("timeupdate", this.onTimeUpdate);
      this.audio.addEventListener("ended", this.onAudioEnded);
      this.audio.addEventListener("pause", this.onTimeUpdate);
      this.audio.addEventListener("play", this.onTimeUpdate);
    }
    this.interval = setInterval(() => {
      if (this.state.playing) {
        this.setState({ deltaTime: ++this.state.deltaTime });
      }
    }, 1000);
  }

  componentWillUnmount() {
    if (this.audio) {
      this.audio.pause();
      this.audio.removeEventListener("loadedmetadata", this.onTimeUpdate);
      this.audio.removeEventListener("timeupdate", this.onTimeUpdate);
      this.audio.removeEventListener("ended", this.onAudioEnded);
      this.audio.removeEventListener("pause", this.onTimeUpdate);
      this.audio.removeEventListener("play", this.onTimeUpdate);
    }
    clearInterval(this.interval);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.state.volume !== this.props.state.volume) this.applyVolume();
  }

  componentWillReceiveProps(nextProps) {
    if (this.audio && this.props.state.url !== nextProps.state.url) {
      this.audio.setAttribute("src", nextProps.state.url);
    }

    if (this.props.state.soundList !== nextProps.state.soundList) {
      this.setState({ playing: false, deltaTime: 0 }, () => {
        if (this.audio) {
          this.audio.pause();
          this.audio.currentTime = 0;
        }
      });
    }
  }
  render() {
    let { props, state } = this.props;
    // The view follows the element (the timeline also starts and stops it); state.playing is the request.
    const isPlaying = !this.state.audioPaused;
    let imagePlayPause = isPlaying ? imagePause : imagePlay;

    if (this.state.playing && this.audio) {
      if (state.soundList == null || state.soundList.length == 0) {
        this.audio.onended = () => {
          this.setState({ playing: false }, () => {
            if (this.audio) {
              this.audio.pause();
            }
          });
        };
      }
    }

    let totalDuration = 0;

    if (state.soundList != null && state.soundList.length > 0) {
      totalDuration =
        state.soundList.reduce(function (prev, curr) {
          return prev.endTime > curr.endTime ? prev : curr;
        }).endTime -
        state.soundList.reduce(function (prev, curr) {
          return prev.startTime < curr.startTime ? prev : curr;
        }).startTime;
    }

    if (
      this.interval != null &&
      this.state.deltaTime > 0 &&
      totalDuration > 0 &&
      this.state.deltaTime >= totalDuration
    ) {
      this.setState(
        {
          deltaTime: 0,
          playing: false,
        },
        () => {
          if (this.audio) {
            this.audio.pause();
            this.audio.currentTime = 0;
          }
        }
      );
    }

    if (
      this.state.playing &&
      this.audio &&
      state.soundList != null &&
      state.soundList.length > 0 &&
      state.soundList.find((sound) => sound.startTime == this.state.deltaTime) != null
    ) {
      let sound = state.soundList.find((sound) => sound.startTime == this.state.deltaTime);
      this.audio.src = sound.file;
      this.audio.volume = sound.volumeLevel;
      this.audio.currentTime = 0;
      this.audio.play();
    } else if (
      this.state.playing &&
      this.audio &&
      state.soundList != null &&
      state.soundList.length > 0 &&
      state.soundList.find((sound) => sound.endTime == this.state.deltaTime) != null
    ) {
      this.audio.src = "";
      this.audio.currentTime = 0;
    }

    if (state.playerView) {
      return (
        <div className={"audioCueConatiner"} style={{ width: "100%", height: "100%" }}>
          <audio
            ref={this.audioRef}
            src={state.url}
            style={{ display: "none" }}
            preload="metadata"
          />
          <AudioCuePlayerBar
            playing={isPlaying}
            currentTime={this.state.currentTime}
            duration={this.state.duration}
            muted={this.state.muted}
            onPlayPause={this.playPause.bind(this)}
            onSeek={this.seek.bind(this)}
            onToggleMute={this.toggleMute.bind(this)}
          />
        </div>
      );
    }

    let useImage = state.useImage;
    return (
      <div className={"audioCueConatiner"} style={{ width: "100%", height: "100%" }}>
        {/* Audio element - timeline ile senkronizasyon için DOM'da olmalı */}
        <audio ref={this.audioRef} src={state.url} style={{ display: "none" }} preload="metadata" />
        <div
          /* onClick={this.playPause.bind(this)}*/ style={{
            height: "100%",
            width: "100%",
            pointerEvents: "initial",
          }}
          className={"draggableImage"}
        >
          <div
            className={"colorBackground"}
            style={{
              height: "100%",
              width: "100%",
              pointerEvents: "initial",
              backgroundColor: state.colorCue,
              visibility: useImage ? "hidden" : "visible",
            }}
          />
          <img
            className="basicImageClass"
            style={{
              overflow: "hidden",
              width: state.allowDeformed ? "100%" : "100%",
              height: state.allowDeformed ? "100%" : "100%",
              visibility: useImage ? "visible" : "hidden",
              position: "absolute",
            }}
            src={state.icon}
          />
          {state.hideAnimation ? null : (
            <div
              className={"loader"}
              id="bars"
              /* onClick={this.playPause.bind(this)}*/ style={{
                position: "absolute",
                display: "block",
              }}
            >
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barUp playing" : "barUp"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />

              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
              <div
                className={isPlaying ? "barDown playing" : "barDown"}
                style={{ animationPlayState: isPlaying ? "running" : "paused" }}
              />
            </div>
          )}
          <img
            onClick={this.playPause.bind(this)}
            className={state.hideAnimation ? "playButtonCentered" : "playButton"}
            src={imagePlayPause}
          />
        </div>
      </div>
    );
  }
}

/* eslint-enable react/prop-types */
